import { render, staticRenderFns } from "./search-contact-list-imports.vue?vue&type=template&id=c0483302&scoped=true&"
import script from "./search-contact-list-imports.vue?vue&type=script&lang=js&"
export * from "./search-contact-list-imports.vue?vue&type=script&lang=js&"
import style0 from "./search-contact-list-imports.vue?vue&type=style&index=0&id=c0483302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0483302",
  null
  
)

export default component.exports